module.exports = __webpack_public_path__ + "img/gold-coin.7d5798c8.svg";